/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var InsurerCode;

(function (InsurerCode) {
  InsurerCode["CHUBB_UK"] = "CHUBB_UK";
  InsurerCode["SAGIC_UK"] = "SAGIC_UK";
  InsurerCode["GREAT_AMERICAN"] = "GREAT_AMERICAN";
  InsurerCode["HISCOX"] = "HISCOX";
  InsurerCode["MS_AMLIN"] = "MS_AMLIN";
  InsurerCode["ACCELERANT"] = "ACCELERANT";
  InsurerCode["ACCELERANT_GIT"] = "ACCELERANT_GIT";
  InsurerCode["ACCELERANT_RECRUITMENT"] = "ACCELERANT_RECRUITMENT";
  InsurerCode["GREAT_AMERICAN_BUSINESS"] = "GREAT_AMERICAN_BUSINESS";
  InsurerCode["HISCOX_US"] = "HISCOX_US";
})(InsurerCode || (InsurerCode = {}));